import { ABtn } from '@maisaedu/ui-components-a-btn';
import { getInitials } from '@/helpers/functions';
import TextSafe from '@/components/text-safe';
import CommonMixin from '@/mixins/templates/common';

export default {
  mixins : [CommonMixin],
  props  : {
    academicMainId: {
      type: Number
    }
  },
  name       : 'CourseApprovalCommentsModal',
  components : {
    ABtn,
    TextSafe
  },
  data() {
    return {
      isCourseCommentsModalOpen : false,
      isLoading                 : false,
      comments                  : []
    };
  },
  watch: {
    async isCourseCommentsModalOpen(newValue) {
      if (newValue) {
        document.documentElement.classList.add('overflow-y-hidden');

        this.fetchComments();
        return;
      }

      document.documentElement.classList.remove('overflow-y-hidden');
    }
  },
  methods: {
    getInitials,
    async fetchComments() {
      try {
        this.isLoading = true;
        const { data } = await this.$services.courses().getModelCourseComments(this.academicMainId);

        this.comments = data;
      } catch (error) {
        this.$toast.error(error.response.data.error.message);
      } finally {
        this.isLoading = false;
      }
    }
  }
};
